import type { ReactNode } from 'react'
import type { ClientContact } from '@/shared/api'
import { clientContactTitle, clientSourceText } from '../model/channel'
import { formatContactValue } from '../model/phone'
import { ClientChannelTile } from './ClientChannelTile'
import s from './ClientChannelRow.module.css'

type ClientChannelRowProps = {
  contact: ClientContact
  /**
   * Действия над каналом — СЛОТОМ, а не внутри строки. Сама строка ничего не умеет менять: в брони
   * она только показывает, в разделе «Гости» рядом с ней живут «метка» и «убрать». Знание о том,
   * какие действия уместны на этом экране, принадлежит экрану.
   */
  actions?: ReactNode
  /** Под значением канала: то, что относится к ЭТОМУ каналу, — например правка его метки. */
  children?: ReactNode
}

/**
 * Строка канала связи с АТРИБУЦИЕЙ.
 *
 * ⚠️ Атрибуция здесь не украшение, а требование §2.2: карточка показывает ВСЕ каналы гостя,
 * включая добавленные другими компаниями, и без строки «кто и как это добавил» менеджер видит
 * незнакомый telegram, не понимая, откуда он взялся и можно ли на него полагаться.
 *
 * Источников у канала бывает несколько, и это осмысленно: менеджер вписал номер руками, потом
 * автоматика подтвердила, что он есть в MAX. Показываем все — сервер отдаёт только живые.
 */
export function ClientChannelRow({ contact, actions, children }: ClientChannelRowProps) {
  return (
    <li className={s.root} data-foreign={contact.editable ? undefined : 'true'}>
      <ClientChannelTile kind={contact.kind} />

      <div className={s.body}>
        <span className={s.title}>{clientContactTitle(contact)}</span>
        {/* Значение — не поле ввода. Исправить номер нельзя в принципе (§2.5): неправильный удаляют
            и добавляют правильный, и поле поверх него обещало бы несуществующее. */}
        <span className={s.value}>{formatContactValue(contact.value)}</span>
        {contact.sources.map((source, index) => (
          <span key={`${source.origin}:${source.firstSeenAt}:${index}`} className={s.source}>
            {clientSourceText(source)}
          </span>
        ))}
        {children}
      </div>

      {actions ? <div className={s.actions}>{actions}</div> : null}
    </li>
  )
}
